/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BucketName {
    CONTACT_DETAILS_FILES = 'CONTACT_DETAILS_FILES',
    INCIDENT_FILES = 'INCIDENT_FILES',
    INQUIRY_FILES = 'INQUIRY_FILES',
    KNOWLEDGE_BASE_FILES = 'KNOWLEDGE_BASE_FILES',
    ORGANIZATION_FILES = 'ORGANIZATION_FILES',
    REFUND_FILES = 'REFUND_FILES',
    RESOLUTION_FILES = 'RESOLUTION_FILES',
    TRANSACTION_FILES = 'TRANSACTION_FILES'
}

